// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-sytp-index-main_right_content-2F6zl","table":"components-fwwgl-sytp-index-table-afUeV"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/sytp/index.css
// module id = 2288
// module chunks = 0